import React from "react";
import "../../css/PrivacyPolicy.css";

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-page">
            <div className="privacy-policy-container">
                <header className="privacy-policy-header">
                    <h1>Privacy Policy</h1>
                    <p className="privacy-policy-meta">
                        <strong>www.bluebird-documentation.com</strong><br />
                        Type of website: Ecommerce<br />
                        Effective date: 1st day of September, 2025
                    </p>
                </header>

                <section>
                    <p>
                        www.bluebird-documentation.com (the "Site") is owned and operated by Yomen Tohmaz.
                        Yomen Tohmaz is the data controller and can be contacted at:{" "}
                        <a href="mailto:yomen.tohmaz@bluebird-documentation.com">
                            yomen.tohmaz@bluebird-documentation.com
                        </a>
                    </p>
                </section>

                <section>
                    <h2>Purpose</h2>
                    <p>
                        The purpose of this privacy policy (this "Privacy Policy") is to inform users of our
                        Site of the following:
                    </p>
                    <ol>
                        <li>The personal data we will collect;</li>
                        <li>Use of collected data;</li>
                        <li>Who has access to the data collected;</li>
                        <li>The rights of Site users; and</li>
                        <li>The Site's cookie policy.</li>
                    </ol>
                    <p>This Privacy Policy applies in addition to the terms and conditions of our Site.</p>
                </section>

                <section>
                    <h2>GDPR</h2>
                    <p>
                        For users in the European Union, we adhere to the Regulation (EU) 2016/679 of the
                        European Parliament and of the Council of 27 April 2016, known as the General Data
                        Protection Regulation (the "GDPR"). For users in the United Kingdom, we adhere to the
                        GDPR as enshrined in the Data Protection Act 2018.
                    </p>
                    <p>
                        We have not appointed a Data Protection Officer as we do not fall within the categories
                        of controllers and processors required to appoint a Data Protection Officer under
                        Article 37 of the GDPR.
                    </p>
                </section>

                <section>
                    <h2>Consent</h2>
                    <p>By using our Site users agree that they consent to:</p>
                    <ol>
                        <li>The conditions set out in this Privacy Policy.</li>
                    </ol>
                    <p>
                        When the legal basis for us processing your personal data is that you have provided your
                        consent to that processing, you may withdraw your consent at any time. If you withdraw
                        your consent, it will not make processing which we completed before you withdrew your
                        consent unlawful.
                    </p>
                    <p>You can withdraw your consent by: Contacting the owner.</p>
                </section>

                <section>
                    <h2>Legal Basis for Processing</h2>
                    <p>
                        We collect and process personal data about users in the EU only when we have a legal
                        basis for doing so under Article 6 of the GDPR.
                    </p>
                    <p>
                        We rely on the following legal basis to collect and process the personal data of users
                        in the EU:
                    </p>
                    <ol>
                        <li>
                            Users have provided their consent to the processing of their data for one or more
                            specific purposes.
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>Personal Data We Collect</h2>
                    <p>
                        We only collect data that helps us achieve the purpose set out in this Privacy Policy.
                        We will not collect any additional data beyond the data listed below without notifying
                        you first.
                    </p>

                    <h3>Data Collected Automatically</h3>
                    <p>
                        When you visit and use our Site, we may automatically collect and store the following
                        information:
                    </p>
                    <ol>
                        <li>IP address;</li>
                        <li>Hardware and software details;</li>
                        <li>Clicked links; and</li>
                        <li>Content viewed.</li>
                    </ol>

                    <h3>Data Collected in a Non-Automatic Way</h3>
                    <p>
                        We may also collect the following data when you perform certain functions on our Site:
                    </p>
                    <ol>
                        <li>First and last name;</li>
                        <li>Email address;</li>
                        <li>Phone number; and</li>
                        <li>Payment information.</li>
                    </ol>
                    <p>This data may be collected using the following methods:</p>
                    <ol>
                        <li>Account registration and checkout forms.</li>
                    </ol>
                </section>

                <section>
                    <h2>How We Use Personal Data</h2>
                    <p>
                        Data collected on our Site will only be used for the purposes specified in this Privacy
                        Policy or indicated on the relevant pages of our Site. We will not use your data beyond
                        what we disclose in this Privacy Policy.
                    </p>
                    <p>The data we collect automatically is used for the following purposes:</p>
                    <ol>
                        <li>Site analytics and improving user experience.</li>
                    </ol>
                    <p>
                        The data we collect when the user performs certain functions may be used for the
                        following purposes:
                    </p>
                    <ol>
                        <li>Account management and service provision.</li>
                    </ol>
                </section>

                <section>
                    <h2>Who We Share Personal Data With</h2>
                    <h3>Employees</h3>
                    <p>
                        We may disclose user data to any member of our organization who reasonably needs access
                        to user data to achieve the purposes set out in this Privacy Policy.
                    </p>

                    <h3>Other Disclosures</h3>
                    <p>
                        We will not sell or share your data with other third parties, except in the following
                        cases:
                    </p>
                    <ol>
                        <li>If the law requires it;</li>
                        <li>If it is required for any legal proceeding;</li>
                        <li>To prove or protect our legal rights; and</li>
                        <li>
                            To buyers or potential buyers of this company in the event that we seek to sell the
                            company.
                        </li>
                    </ol>
                    <h3>Service Providers for Audio Transcription</h3>
                    <p>
                        If you use the audio transcription feature, the audio you upload or record is sent to a
                        third-party speech-to-text provider (currently Groq, Inc.) to produce a transcript, and
                        the transcript, together with any summary instructions you enter, is sent to Anthropic,
                        PBC to produce a summary. We use both providers through their API services, under
                        terms that do not permit them to use your content to train their models. The audio file
                        is deleted from our servers as soon as processing finishes; the transcript and summary
                        remain in your account until you delete them.
                    </p>
                    <p>
                        If you follow hyperlinks from our Site to another Site, please note that we are not
                        responsible for and have no control over their privacy policies and practices.
                    </p>
                </section>

                <section>
                    <h2>How Long We Store Personal Data</h2>
                    <p>
                        User data will be stored until the purpose the data was collected for has been achieved.
                    </p>
                    <p>You will be notified if your data is kept for longer than this period.</p>
                </section>

                <section>
                    <h2>How We Protect Your Personal Data</h2>
                    <p>
                        In order to protect your security, we use the strongest available browser encryption
                        and store all of our data on servers in secure facilities. All data is only accessible
                        to our employees. Our employees are bound by strict confidentiality agreements and a
                        breach of this agreement would result in the employee's termination.
                    </p>
                    <p>
                        While we take all reasonable precautions to ensure that user data is secure and that
                        users are protected, there always remains the risk of harm. The Internet as a whole can
                        be insecure at times and therefore we are unable to guarantee the security of user data
                        beyond what is reasonably practical.
                    </p>
                </section>

                <section>
                    <h2>Your Rights as a User</h2>
                    <p>Under the GDPR, you have the following rights:</p>
                    <ol>
                        <li>Right to be informed;</li>
                        <li>Right of access;</li>
                        <li>Right to rectification;</li>
                        <li>Right to erasure;</li>
                        <li>Right to restrict processing;</li>
                        <li>Right to data portability; and</li>
                        <li>Right to object.</li>
                    </ol>
                </section>

                <section>
                    <h2>Children</h2>
                    <p>
                        We do not knowingly collect or use personal data from children under 16 years of age.
                        If we learn that we have collected personal data from a child under 16 years of age,
                        the personal data will be deleted as soon as possible. If a child under 16 years of age
                        has provided us with personal data their parent or guardian may contact our privacy
                        officer.
                    </p>
                </section>

                <section>
                    <h2>How to Access, Modify, Delete, or Challenge the Data Collected</h2>
                    <p>
                        If you would like to know if we have collected your personal data, how we have used
                        your personal data, if we have disclosed your personal data and to who we disclosed
                        your personal data, if you would like your data to be deleted or modified in any way,
                        or if you would like to exercise any of your other rights under the GDPR, please
                        contact our privacy officer here:
                    </p>
                    <p>
                        Yomen Tohmaz<br />
                        <a href="mailto:yomen.tohmaz@bluebird-documentation.com">
                            yomen.tohmaz@bluebird-documentation.com
                        </a>
                    </p>
                </section>

                <section>
                    <h2>Cookie Policy</h2>
                    <p>
                        A cookie is a small file, stored on a user's hard drive by a website. Its purpose is
                        to collect data relating to the user's browsing habits. You can choose to be notified
                        each time a cookie is transmitted. You can also choose to disable cookies entirely in
                        your internet browser, but this may decrease the quality of your user experience.
                    </p>
                    <p>We use the following types of cookies on our Site:</p>
                    <ol>
                        <li>
                            <strong>Functional cookies</strong> — Functional cookies are used to remember the
                            selections you make on our Site so that your selections are saved for your next
                            visits; and
                        </li>
                        <li>
                            <strong>Analytical cookies</strong> — Analytical cookies allow us to improve the
                            design and functionality of our Site by collecting data on how you access our Site,
                            for example data on the content you access, how long you stay on our Site, etc.
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>Modifications</h2>
                    <p>
                        This Privacy Policy may be amended from time to time in order to maintain compliance
                        with the law and to reflect any changes to our data collection process. When we amend
                        this Privacy Policy we will update the "Effective Date" at the top of this Privacy
                        Policy. We recommend that our users periodically review our Privacy Policy to ensure
                        that they are notified of any updates. If necessary, we may notify users by email of
                        changes to this Privacy Policy.
                    </p>
                </section>

                <section>
                    <h2>Complaints</h2>
                    <p>
                        If you have any complaints about how we process your personal data, please contact us
                        through the contact methods listed in the Contact Information section so that we can,
                        where possible, resolve the issue. If you feel we have not addressed your concern in a
                        satisfactory manner you may contact a supervisory authority. You also have the right to
                        directly make a complaint to a supervisory authority. You can lodge a complaint with a
                        supervisory authority by contacting the Product Owner.
                    </p>
                </section>

                <section>
                    <h2>Contact Information</h2>
                    <p>
                        If you have any questions, concerns or complaints, you can contact our privacy officer,
                        Yomen Tohmaz, at:
                    </p>
                    <p>
                        <a href="mailto:yomen.tohmaz@bluebird-documentation.com">
                            yomen.tohmaz@bluebird-documentation.com
                        </a>
                    </p>
                </section>

                <footer className="privacy-policy-footer">
                    <p>© 2025 Bluebird Documentation. All rights reserved.</p>
                </footer>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
